<template> 
  <section class="itinerario-poster" ref="sectionRef"> 
 
    <!-- VIDEO BACKGROUND --> 
    <video 
      class="video-bg" 
      autoplay 
      muted 
      loop 
      playsinline 
      webkit-playsinline 
      preload="auto" 
    > 
      <source src="@/assets/vv1.mp4" type="video/mp4" /> 
    </video> 
 
    <!-- OVERLAY FOR BETTER VISIBILITY --> 
    <div class="overlay"></div> 
 
    <!-- TOP TORN PAPER --> 
    <div class="rasgado rasgado-top"></div> 
 
    <h2 class="poster-title">Itinerary</h2> 
    <span class="sub"> 
      We appreciate your punctuality. <br /> 
      We don't want to start without you or have you miss any special moment! Arrive on time to share every moment of this special night. 
    </span> 
 
    <div 
      v-for="(evento, index) in eventos" 
      :key="evento.nombre" 
      class="poster-item" 
      :ref="el => itemRefs[index] = el" 
    > 
      <img :src="evento.icono" class="poster-icon" /> 
      <p class="poster-text"> 
        <span class="evento-nombre">{{ evento.nombre }}</span> 
        <span class="evento-hora">{{ evento.hora }}</span> 
        <span v-if="evento.nota" class="evento-nota">{{ evento.nota }}</span> 
      </p> 
    </div> 
 
    <!-- BOTTOM TORN PAPER --> 
    <div class="rasgado rasgado-bottom"></div> 
 
  </section> 
</template> 

<script> 
import { ref, onMounted } from 'vue' 
import gsap from 'gsap' 
 
export default { 
  name: 'ItinerarioPoster', 
  setup() { 
    const eventos = [ 
      { 
        nombre: 'Ceremony ', 
        hora: '3:00 PM', 
        icono: require('@/assets/co.png') 
      }, 
      { 
        nombre: 'Dinner', 
        hora: '5:00 PM', 
        icono: require('@/assets/cena.png') 
      }, 
      { 
        nombre: 'Merch', 
        hora: '8:00 PM', 
        icono: require('@/assets/mon1.png') 
      }, 
      { 
        nombre: ' Party', 
        hora: '9:00 PM - 12:00 AM', 
        icono: require('@/assets/disc.png') 
      } 
    ] 
 
    const itemRefs = ref([]) 
    const sectionRef = ref(null) 
 
    onMounted(() => { 
      itemRefs.value.forEach((el, index) => { 
        if (!el) return 
 
        const icon = el.querySelector('.poster-icon') 
        const text = el.querySelector('.poster-text') 
 
        gsap.set([icon, text], { opacity: 0 }) 
 
        const animations = [ 
          { y: 40 }, 
          { x: -40 }, 
          { scale: 0.85 }, 
          { x: 40 }, 
          { y: -40 }, 
          { scale: 0.9 }, 
          { x: -30 }, 
          { y: 30 } 
        ] 
 
        const fromVars = animations[index % animations.length] 
 
        const observer = new IntersectionObserver((entries, obs) => { 
          entries.forEach(entry => { 
            if (!entry.isIntersecting) return 
 
            gsap.fromTo( 
              icon, 
              { ...fromVars, opacity: 0 }, 
              { opacity: 1, x: 0, y: 0, scale: 1, duration: 1, ease: 'power3.out' } 
            ) 
 
            gsap.fromTo( 
              text, 
              { y: 20, opacity: 0 }, 
              { y: 0, opacity: 1, duration: 1, delay: 0.2, ease: 'power2.out' } 
            ) 
 
            obs.unobserve(entry.target) 
          }) 
        }, { threshold: 0.3 }) 
 
        observer.observe(el) 
      }) 
    }) 
 
    return { eventos, itemRefs, sectionRef } 
  } 
} 
</script>
<style scoped>
.itinerario-poster {
  position: relative; /* 🔥 CLAVE PARA QUE EL RASGADO FUNCIONE */
  overflow: hidden;
  padding: 60px 20px 80px;
  text-align: center;
}
.video-fondo{
  position:absolute;
  inset:0;
  width:100%;
  height:100%;
  object-fit:cover;
  z-index:0;
  pointer-events:none; /* 🔥 evita bugs en mobile */
}

/* VIDEO */
.video-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* Filtros para aclarar */
 
  object-fit: cover;
  z-index: 0;
}

/* OVERLAY */
.overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1;
}

/* CONTENIDO ARRIBA */
.poster-title,
.poster-item {
  position: relative;
  z-index: 2;
}

/* TEXTO BLANCO */
.poster-title {
  font-family: 'titulos', cursive;
  font-size: 68px;
  letter-spacing: 2px;
  color: #ffffff;
  margin-bottom: 50px;
}
.sub {
  font-family: 'Playfair Display', serif;
  color: #ffffff;
  line-height: 1.4;
  position: relative;
  z-index: 2;
  display: block;
  margin-bottom: 30px;
margin-top:-20px;
  opacity: 1;
}
.poster-text {
  font-family: 'Playfair Display', serif;
  color: #ffffff;
  line-height: 1.4;
}

.evento-nombre {
  display: block;
  font-size: 22px;
}

.evento-hora {
  display: block;
  font-size: 22px;
  font-style: italic;
  margin-top: 4px;
  color: #ffffff;
}

.evento-nota {
  display: block;
  font-size: 14px;
  margin-top: 6px;
  color: #ffffff;
}

/* ICONO */
.poster-icon {
  width: 114px;
  height: auto;
  margin-bottom: 12px;
  position: relative;
  z-index: 2;
}

/* ITEMS */
.poster-item {
  margin-bottom: 42px;
}

/* RASGADOS */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  z-index: 3;
  pointer-events: none;
}

.rasgado-top {
  top: 0;
  background: #e8dacc;
 clip-path: polygon(
    0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%
  );
}

.rasgado-bottom {
  bottom: 0;
  background: #e8dacc;
  clip-path: polygon(
    0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%
  );
}
</style>